var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("DispositivosExtendidoActividad", {
    attrs: {
      id: _vm.params.data.idInterno,
      "actividad-extendida": _vm.params.data.extendida
    }
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }